import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Card, makeStyles, Typography } from '@material-ui/core';
import styles from './styles';

const useStyles = makeStyles(styles);

interface SliderFieldProps {
  label: string;
  slider: JSX.Element;
  input: JSX.Element;
  sliderLabel?: string;
}

const SliderField: React.FC<SliderFieldProps> = ({
  label,
  slider,
  input,
  sliderLabel,
}) => {
  const classes = useStyles();

  return (
    <Card data-testid="slider-field" className={classes.blankCard}>
      <Grid container spacing={1} className={classes.sliderRoot}>
        <Grid item xs={12} className={classes.labelContainer}>
          <Typography
            variant="caption"
            component="span"
            className={classes.title}
          >
            {label}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} className={classes.leftContainer}>
          <Grid item className={classes.fullWidth}>
            <Typography variant="caption" component="span">
              {sliderLabel}
            </Typography>
          </Grid>
          <Grid item className={classes.fullWidth}>
            {slider}
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.input}>
          {input}
        </Grid>
      </Grid>
    </Card>
  );
};

export default SliderField;
